import React from 'react';
import { Button, Confirm, Form, FormField, Header, Icon, Modal, Portal, Segment } from 'semantic-ui-react';
import { SearchData, ISearchData } from '../../models';
import DatePicker from 'react-datepicker';
import { IDataService, DataService } from '../../services';
import { appInsights } from '../../AppInsights';
import { IUpdateDocument } from '../../intefaces';


interface IDocumentProps {
    className?: string;
    searchText: string;
    id: string;
    author: string;
    title: string[];
    division: string;
    contractDate: string;
    agency: string;
    documentType: string[];
    counterparties: string;
    counterparties2: string;
    updated: any;
    deleted: any;
}

interface IDocumntState {
    modalOpen: boolean;
    portalOpen: boolean;
    confirmationOpen: boolean;
    author: string;
    title: string[];
    division: string;
    divisionList: ISearchData[];
    contractDate: Date;
    agency: string;
    agencyList: any;
    documentType: string[];
    documentTypeList: ISearchData[];
    counterparties: string;
    counterparties2: string;
    isSuccess: boolean;
}

export class DocumentEdit extends React.Component<IDocumentProps, IDocumntState> {
    private searchData = new SearchData();
    private _dataService: IDataService = new DataService();

    constructor(props: IDocumentProps) {
        super(props);
        this.state = {
            modalOpen: false,
            portalOpen: false,
            confirmationOpen: false,
            author: this.props.author,
            title: this.props.title,
            division: this.props.division,
            divisionList: [],
            contractDate: new Date(),
            agency: this.props.agency,
            agencyList: [],
            documentType: this.props.documentType,
            documentTypeList: [],
            counterparties: this.props.counterparties,
            counterparties2: this.props.counterparties2,
            isSuccess: false,
        }
    }

    public async componentDidMount() {
        let newDate = new Date();
        try {
            if (this.props.contractDate != 'Date unknown') {
                newDate = new Date(this.props.contractDate);
            }
        } catch (e) {
            let err: Error = new Error('(Document Edit) Date parse error: ' + e);
            
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
            console.error(err);
        }

        this.setState({
            divisionList: await this.searchData.Division(),
            contractDate: newDate,
            agencyList: await this.searchData.Agency(),
            documentTypeList: await this.searchData.DocumentType()
        });
    }

    public render() {
        return (
            <>
                <Modal
                    onClose={() => this.setState({ modalOpen: false })}
                    onOpen={() => this.setState({ modalOpen: true })}
                    open={this.state.modalOpen}
                    trigger={<Button className={this.props.className}>Edit Contract</Button>}
                    size={'small'}
                    onChange={() => { }}
                >
                    <Modal.Header>Edit <i>{this.state.title}</i></Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field id='author'>
                                <label>Author</label>
                                <Form.Input key='author' fluid placeholder='Author' defaultValue={this.state.author} onBlur={(e: any) => { this.onBlurAuthor(e) }} />
                            </Form.Field>
                            <Form.Field id='title'>
                                <label>Title</label>
                                {this.state.title.map((singleTitle, key) =>
                                    <Form.Group key={'title_'+key}>
                                        <Form.Input key={singleTitle} id={this.uuid()} fluid placeholder='Title' defaultValue={singleTitle} width={12} onBlur={(e: any, d: any) => { this.onBlurTitleBox(e, singleTitle) }} />
                                        <Form.Button icon onClick={(e) => this.onTitleRemove(e, singleTitle)}><Icon name='minus' /></Form.Button>
                                    </Form.Group>
                                )}
                                <Button icon onClick={() => this.addTitle()} ><Icon name='plus' /> Add</Button>
                            </Form.Field>
                            <FormField id='division'>
                                <Form.Select
                                    fluid
                                    search
                                    label='Division'
                                    defaultValue={this.state.division}
                                    options={this.state.divisionList}
                                    placeholder='Division'
                                    onChange={(e, d) => this.onDivisionChange(e, d)}
                                />
                            </FormField>
                            <FormField id='contractDate'>
                                <label>Contract Date</label>
                                <DatePicker
                                    selected={this.state.contractDate || new Date()}
                                    onChange={date => this.handleStartChange(date)}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText='dd/MM/YYYY'
                                />
                            </FormField>
                            <FormField id='agency'>
                                <Form.Select
                                    key={this.uuid()}
                                    fluid
                                    search
                                    label='Agency'
                                    defaultValue={this.state.agency}
                                    options={this.state.agencyList}
                                    placeholder='Agency'
                                    onChange={(e, d) => this.onAgencyChange(e, d)}
                                />
                            </FormField>
                            <Form.Field id='documentType'>
                                <label>Document Type</label>
                                {this.state.documentType.map((singleDocument, key) =>
                                    <Form.Group key={'dt_' + singleDocument}>
                                        <Form.Select
                                            key={this.uuid()}
                                            search 
                                            options={this.state.documentTypeList}
                                            fluid
                                            width={12}
                                            placeholder='Document Type'
                                            defaultValue={singleDocument}
                                            onChange={(e: any, d: any) => { this.onChangeDocumentType(e, d) }} />
                                        <Form.Button icon onClick={(e) => this.onDocumentTypeRemove(e, singleDocument)}><Icon name='minus' /></Form.Button>
                                    </Form.Group>
                                )}
                                <Button icon onClick={() => this.addDocumentType()} ><Icon name='plus' /> Add</Button>
                            </Form.Field>
                            <Form.Field id='counterparties'>
                                <label>Counterparties 1</label>
                                <Form.Input key='counterparties' fluid placeholder='Counterparties 1' defaultValue={this.state.counterparties} onBlur={(e: any) => { this.onBlurCounterparties(e) }} />
                            </Form.Field>
                            <Form.Field id='counterparties2'>
                                <label>Counterparties 2</label>
                                <Form.Input key='counterparties2' fluid placeholder='Counterparties 2' defaultValue={this.state.counterparties2} onBlur={(e: any) => { this.onBlurCounterparties2(e) }} />
                            </Form.Field>
                            <Button type='submit' onClick={() => this.onSubmit()}>Save</Button>
                            <Button type='button' onClick={() => this.onCancel()}>Cancel</Button>
                            <Button
                                content='Delete'
                                floated='right'
                                color='red'
                                onClick={() => { this.setState({ confirmationOpen: true }) }}
                            />
                        </Form>
                    </Modal.Content>

                    <Portal onClose={() => { this.setState({ portalOpen: false, modalOpen: false }); }} open={this.state.portalOpen}>
                        <Segment
                            style={{
                                left: '40%',
                                position: 'fixed',
                                top: '50%',
                                zIndex: 1000,
                            }}
                        >
                            <Header>{this.state.isSuccess ? 'Document updated' : 'Error during update'}</Header>
                            {this.state.isSuccess ?
                                <p>
                                    <Icon name='check circle outline' color='green' size='big' />
                                    Success
                                </p>
                                :
                                <p>
                                    <Icon name='delete' color='red' size='big' />
                                    Document failed to be updated, please try again. <br />
                                    If this issue persists please contact the service desk.
                                </p>
                            }

                            <Button
                                content='Close'
                                negative
                                onClick={() => { this.setState({ portalOpen: false, modalOpen: false }); this.props.updated(true) }}
                            />
                        </Segment>
                    </Portal>

                    <Confirm
                        open={this.state.confirmationOpen}
                        onCancel={() => this.setState({ confirmationOpen: false })}
                        onConfirm={() => this.onDeleteDocs()}
                        confirmButton='Yes'
                        content='This will remove the entire document from Themis. Are you sure you want to delete?'
                    />
                </Modal >
            </>
        );
    }


    /** Remove document */
    private async onDeleteDocs() {
        try {

            let results = await this._dataService.CallDeleteDocumentApi(this.props.id);
            if (results == 'Deleted') { this.props.deleted(true) }

        }
        catch (e) {
            let err = new Error('Error during delete document: ' + e);
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
            console.error(err);
        }
    }


    private onCancel() {

        let newDate = new Date();
        if (this.props.contractDate != 'Date unknown') {
                newDate = new Date(this.props.contractDate);
        }

        this.setState({ 
            modalOpen: false,
            author: this.props.author,
            title: this.props.title,
            division: this.props.division,
            contractDate: newDate,
            agency: this.props.agency,
            documentType: this.props.documentType,
            counterparties: this.props.counterparties,
            counterparties2: this.props.counterparties2,
        })
    }

    /** Submit */
    private async onSubmit() {
        let index: IUpdateDocument = {
            id: this.props.id,
            author: this.state.author,
            title: this.state.title,
            division: this.state.division,
            contractDate: this.state.contractDate.toISOString(),
            agency: this.state.agency,
            documentType: this.state.documentType,
            counterparties: this.state.counterparties,
            counterparties2: this.state.counterparties2
        };

        try {

            let results = await this._dataService.CallUpdateDocumentApi(index);
            if (results == 'Updated') { this.setState({ isSuccess: true }) }

        }
        catch (e) {
            let err = new Error('Error during saving document: ' + e);
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
            console.error(err);
        }

        this.setState({ portalOpen: true });

    }

    /** Author edit methods */
    private onBlurAuthor(e: any) {
        this.setState({
            author: e.target.value
        });
    }

    /** Title edit methods */
    private onBlurTitleBox(e: any, d: any) {
        let title = this.state.title;
        let index = -1;
        if (d !== undefined) {
            index = title.indexOf(d);
        }
        if (index == -1) {
            index = title.indexOf('');
        }
        title[index] = e.target.value;
        this.setState({
            title: title
        });
    }

    private onTitleRemove(e: any, d: any) {
        let title: string[] = [];
        this.state.title.map(element => {
            if (element != d) {
                title.push(element);
            }
        }
        );

        this.setState({
            title: title
        });
    }

    private addTitle() {
        let title = this.state.title;
        title.push('');
        this.setState({
            title: title
        });
    }

    /** Division edit method */
    private onDivisionChange(e: any, d: any) {
        this.setState({
            division: d.value
        });
    }

    /** ContractDate edit method */
    private handleStartChange(date: any) {
        this.setState({
            contractDate: date
        });
    }

    /** Agency edit method */
    private onAgencyChange(e: any, d: any) {
        this.setState({
            agency: d.value
        });
    }

    /** DocumentType edit methods */
    private onChangeDocumentType(e: any, d: any) {
        let documentType = this.state.documentType;
        let index = -1;
        if (d.value !== undefined) {
            index = documentType.indexOf(d.value);
        }
        if (index == -1) {
            index = documentType.indexOf('');
        }

        documentType[index] = d.value;
        this.setState({
            documentType: documentType
        });
    }

    private onDocumentTypeRemove(e: any, d: any) {
        let documentType: string[] = [];
        this.state.documentType.map(element => {
            if (element != d) {
                documentType.push(element);
            }
        }
        );

        this.setState({
            documentType: documentType
        });
    }

    private addDocumentType() {
        let documentType = this.state.documentType;
        documentType.push('');
        this.setState({
            documentType: documentType
        });
    }

    /** Counterparties edit methods */
    private onBlurCounterparties(e: any) {
        this.setState({
            counterparties: e.target.value
        });
    }

    /** Counterparties2 edit methods */
    private onBlurCounterparties2(e: any) {
        this.setState({
            counterparties2: e.target.value
        });
    }

    /** uuid generator */

    private uuid() {
        var uuidValue = "", k, randomValue;
        for (k = 0; k < 32; k++) {
            randomValue = Math.random() * 16 | 0;

            if (k == 8 || k == 12 || k == 16 || k == 20) {
                uuidValue += "-"
            }
            uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
        }
        return uuidValue;
    }

};

